
const debug = false

export const logger = (label) => (...args) => debug && console.log(label, ...args)
